<template>
  <div class="chart-zones-container">
    <div class="text-container">
      <div class="title-div">
        <span class="title" style="margin: 0 0 0 28px">Zone</span>
        <span class="title" style="float: right">Total selected</span>
        <hr class="line-class" />
      </div>
      <div
        class="text_labels"
        v-for="field in getBookingsPerField"
        v-bind:key="field.id"
      >
        <h4 class="head">{{ field.name }}</h4>
        <h4 class="head procent">{{ field.bookings }}</h4>
        <span class="dot" :class="`color-${field.id}`"></span>
        <div class="body"></div>
      </div>
    </div>

    <div class="chart-container">
      <v-chart :options="option" :autoresize="true" id="pie-chart"></v-chart>
    </div>
  </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/pie";
import { mapGetters } from "vuex";

export default {
  name: "zonstCHart",
  props: ["timePeriod"],

  data: function() {
    return {
      option: {},
      totalBookings: 0,
    };
  },
  components: {
    "v-chart": ECharts,
  },
  computed: {
    ...mapGetters(["getBookingsPerField"]),
  },

  watch: {
    getBookingsPerField() {
      this.getData();
      this.drawGraph();
    },
  },

  methods: {
    getData() {
      var sum = 0;
      var seriesData = this.getBookingsPerField.map((fieldData) => {
        sum += fieldData.bookings;
        return {
          value: fieldData.bookings,
          name: fieldData.name,
          itemStyle: { color: this.getColor(fieldData.id) },
        };
      });
      this.data = seriesData;
      this.totalBookings = sum;
    },
    getColor(id) {
      switch (id) {
        case 1:
          return "#36a336";
        case 2:
          return "#45a9ff";
        case 3:
          return "#3946d9";
        case 4:
          return "#d505ff";
        case 5:
          return "#f7941e";
        case 6:
          return "#ffe200";
        case 7:
          return "#fd2d2d";
        case 14:
          return "#45a9ff";
        case 15:
          return "#36a336";
        case 16:
          return "#3946d9";
      }
    },

    drawGraph() {
      this.option = {
        grid: {
          left: "140",
        },
        backgroundColor: "#383838",
        series: [
          {
            name: "Inner",
            type: "pie",
            selectedMode: "single",
            radius: [0, "10%"],
            itemStyle: { color: "#383838" },

            label: {
              position: "center",
              color: "#ffffff",
              fontSize: 35,
              formatter: " {c} \n {hr|{b}}   ",
              rich: {
                hr: {
                  color: "#ffffff",
                  align: "center",
                  fontSize: 16,
                },
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: this.totalBookings,
                name: "Total selected",
              },
            ],
          },
          {
            name: "Total selected: ",
            type: "pie",
            radius: ["45%", "33%"],
            width: "100%",
            height: "100%",
            center: ["50%", "50%"],
            animationDuration: 0,
            hoverAnimation: false,
            avoidLabelOverlap: true,
            stillShowZeroSum: false,
            minShowLabelAngle: 1,

            silent: true,
            cursor: "auto",
            left: 0,
            right: 0,

            label: {
              width: 5,
              padding: [0, 0, 18, 0],
              margin: "50%",
              formatter: " {perB|{b}} {perD|{d}%}  \n  {hr|}  ",
              rich: {
                // {a}: series name.
                // {b}: the name of a data item.
                // {c}: the value of a data item.
                // {d}: the percent.
                hr: {
                  borderColor: "#747474",
                  opacity: 0.6,
                  width: "90%",
                  borderWidth: 0.5,
                  height: 0,
                },
                a: {
                  fontSize: 14,
                  lineHeight: 19,
                  color: "#AFAFAF",
                  fontFamily: "Montserrat-Regular",
                },
                b: {
                  fontSize: 16,
                  lineHeight: 33,
                },
                perB: {
                  color: "#ffffff",
                  borderRadius: 2,
                  fontSize: 14,
                  fontFamily: "Montserrat-Regular",
                  width: 120,
                },
                perD: {
                  color: "#ffffff",
                  borderRadius: 2,
                  fontSize: 16,
                  fontFamily: "Montserrat-Regular",
                  padding: [0, 0, 0, 10],
                  width: 60,
                },
                perA: {
                  color: "#ffffff",
                  borderRadius: 2,
                  fontSize: 14,
                  fontFamily: "Montserrat-Regular",
                  width: 30,
                },
                perC: {
                  color: "#ffffff",
                  borderRadius: 2,
                  fontSize: 16,
                  fontFamily: "Montserrat-Regular",
                },
              },
            },
            labelLine: {
              length: 100,
              length2: 30,
              lineStyle: {
                color: "#818181",
              },
            },
            itemStyle: {},
            data: this.data,
          },
        ],
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.third-section {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #383838;
}

.chart-zones-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 10px auto;
  overflow: hidden;
  align-content: space-between;
  justify-content: space-between;
}

@media (min-width: 768px) {
  .chart-zones-container {
    flex-flow: row nowrap;
  }
  .chart-zones-container > div {
    width: 33.33% !important;
  }
  .chart-zones-container > .text-container {
    order: 1;
  }
  .chart-zones-container > .chart-container {
    order: 2;
  }
}

.chart-container {
  flex: 1;
}

.chart-container > .text-container {
  flex: 0.5;
}

#pie-chart {
  display: flex;
  height: 100%;
  width: 100%;
}

#pie-chart > div {
  display: flex;
  width: inherit;
}

.text-container * {
  background-color: #383838;
}
.text-container {
  padding: 99px 100px 120px 30px;
  background-color: #383838;
}
.text-container:hover {
  cursor: default;
}
.text_labels {
  width: 272px;
}

.title-div {
  width: 272px;
  margin: -40px 0 30px 0;
}

.title {
  font-size: 14px;
  font-family: Montserrat-Regular;
  opacity: 0.6;
}
.line-class {
  height: 0;
  width: 248px;
  margin: 5px 26px 0;
  border: solid 1px #707070;
}
.head {
  display: inline-block;
  margin-bottom: 24px;
  height: 22px;
  font-family: Montserrat-Regular;
  font-size: 18px;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
}
.procent {
  float: right;
  //   opacity: 0.7;
  //   font-size: 16px;
}
.body-line {
  height: 19px;
  opacity: 0.6;
  font-family: Montserrat-Regular;
  font-size: 16px;
  line-height: 1.19;
  text-align: left;
  color: #ffffff;
  display: inline-block;
}
.body {
  margin-bottom: 16px;
}
.agility_body {
  margin-bottom: 8px;
}

.dot {
  border-radius: 50%;
  // display: inline-block;
  width: 8px;
  height: 8px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  margin: 6px 21px 0 0;
  float: left;
}
.color-1 {
  border: solid 2px #36a336;
  background-color: #36a336;
}
.color-2 {
  border: solid 2px #45a9ff;
  background-color: #45a9ff;
}
.color-3 {
  border: solid 2px #3744d3;
  background-color: #3946d9;
}
.color-4 {
  border: solid 2px #d505ff;
  background-color: #d505ff;
}
.color-5 {
  border: solid 2px #f7941e;
  background-color: #f7941e;
}
.color-6 {
  border: solid 2px #ffe200;
  background-color: #ffe200;
}
.color-7 {
  border: solid 2px #fd2d2d;
  background-color: #fd2d2d;
}
.color-15 {
  border: solid 2px #36a336;
  background-color: #36a336;
}
.color-14 {
  border: solid 2px #45a9ff;
  background-color: #45a9ff;
}

.color-16 {
  border: solid 2px #3744d3;
  background-color: #3946d9;
}
</style>
